import type { IEmployeeTalkState } from '@sharedInterfaces/IEmployeeTalkState';
import { useCallback, useEffect, useRef } from 'react';

export const useComponentData = (talkState: IEmployeeTalkState | null) => {
    // Use ref to avoid recreating getComponentData on every talkState change
    const talkStateRef = useRef(talkState);

    useEffect(() => {
        talkStateRef.current = talkState;
    }, [talkState]);

    const getComponentData = useCallback(
        <T>(componentId: string): T | undefined => {
            const componentState = talkStateRef.current?.components[componentId];
            return componentState?.value as T | undefined;
        },
        [], // No dependencies - stable reference
    );

    return { getComponentData };
};
